import Vue from "vue";
import Vuex from "vuex";
import users from "./modules/users.js";
import options from "./modules/options.js";
import departments from "./modules/departments";
import filiations from "./modules/filiations";
import contracts from "./modules/contracts";
import cards from "./modules/cards";
import returnReasons from "./modules/returnReasons";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    windowWidth: window.innerWidth,
    isMobile: window.innerWidth < 608,
  },
  mutations: {
    SET_IS_MOBILE(state, isMobile) {
      state.isMobile = isMobile;
    },
    SET_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
    },
  },
  actions: {},
  modules: {
    users,
    options,
    departments,
    filiations,
    contracts,
    cards,
    returnReasons,
  },
});
